(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-logo"] && !Shopify.designMode) return;
  try {
    // Initialize logo sparkles for inverse logo
  document.addEventListener('DOMContentLoaded', function () {
    const sparkleContainer = document.querySelector('.header-logo__sparkle-container');
    const sparkleOverlay = document.querySelector('[data-logo-sparkles]');

    if (sparkleContainer && sparkleOverlay) {
      // Wait for LogoSparkles to be available
      if (typeof LogoSparkles !== 'undefined') {
        const logoSparkles = new LogoSparkles(sparkleContainer);

        // Clean up when logo switches
        const inverseLogoContainer = document.querySelector('.header-logo__image-container--inverse');
        if (inverseLogoContainer) {
          const observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                const target = mutation.target;
                if (target.classList.contains('header-logo__image-container--inverse')) {
                  const isVisible = target.style.display !== 'none';
                  if (!isVisible && logoSparkles) {
                    // logoSparkles.destroy();
                  }
                }
              }
            });
          });

          observer.observe(inverseLogoContainer, { attributes: true, attributeFilter: ['style'] });
        }
      }
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["recommended-product"] && !Shopify.designMode) return;
  try {
    (function () {
    const productDataCache = new Map();

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    function init() {
      const recommendedProductSection = document.querySelector('.recommended-product[data-url]');
      if (!recommendedProductSection) {
        console.warn('[Recommended Product] Section not found');
        return;
      }

      const blockId = recommendedProductSection.dataset.blockId;
      const url = recommendedProductSection.dataset.url;
      if (!url) {
        console.warn('[Recommended Product] No URL found');
        return;
      }

      console.log('[Recommended Product] Fetching recommendations from:', url);

      fetch(url, {
        credentials: 'same-origin',
        headers: {
          Accept: 'text/html',
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.text();
        })
        .then((text) => {
          console.log('[Recommended Product] Response received, length:', text.length);
          const html = document.createElement('div');
          html.innerHTML = text;

          // The API returns the section HTML, find our block by ID
          let responseBlock = null;
          if (blockId) {
            responseBlock = html.querySelector(`#recommended-product-${blockId}`);
          }

          if (responseBlock) {
            console.log('[Recommended Product] Block found in response');
            console.log('[Recommended Product] Response block HTML length:', responseBlock.innerHTML.length);
            console.log(
              '[Recommended Product] Current section HTML before replace:',
              recommendedProductSection.innerHTML.length
            );

            // Check if the response block has content (recommendations.performed check)
            const responseWrapper = responseBlock.querySelector('.recommended-product__wrapper');
            const responseContent = responseBlock.querySelector('.recommended-product__content');

            // If the response has empty content (likely because product is in cart),
            // we still want to show it on the PDP. The Liquid condition might have filtered it out,
            // but for PDP we always want to show recommendations even if they're in the cart.
            if (!responseContent || responseContent.innerHTML.trim().length === 0) {
              console.warn('[Recommended Product] Response block has empty content - may be filtered due to cart');
              // For PDP, we want to show recommendations even if they're in the cart.
              // If the API filtered it out, we'll need to fetch it differently.
              // For now, we'll still replace with empty content, but the wrapper is already rendered
              // so JavaScript can potentially fetch recommendations another way if needed.
            }

            // Found our block in the response, replace the entire innerHTML
            // This includes the wrapper and all content
            // NOTE: For PDP, we always show recommendations even if products are in cart.
            // If the response is empty due to cart filtering, we'll still replace it,
            // but the wrapper structure remains so the component can be populated.
            recommendedProductSection.innerHTML = responseBlock.innerHTML;

            // Force custom elements to reconnect by cloning and replacing them
            // This ensures connectedCallback is called and event handlers are registered
            // We need to create new instances of the custom elements, not just clone them
            const customElementsToUpgrade = recommendedProductSection.querySelectorAll('product-form-component');
            customElementsToUpgrade.forEach((element) => {
              if (element.parentNode) {
                const parent = element.parentNode;
                const nextSibling = element.nextSibling;

                // Create a new instance of the custom element instead of cloning
                const tagName = element.tagName.toLowerCase();
                const newElement = document.createElement(tagName);

                // Copy all attributes
                Array.from(element.attributes).forEach((attr) => {
                  newElement.setAttribute(attr.name, attr.value);
                });

                // Copy innerHTML
                newElement.innerHTML = element.innerHTML;

                // Replace the old element with the new one
                parent.removeChild(element);
                parent.insertBefore(newElement, nextSibling);
              }
            });

            console.log(
              '[Recommended Product] After replace, section HTML length:',
              recommendedProductSection.innerHTML.length
            );

            // Check if content was actually populated
            const wrapper = recommendedProductSection.querySelector('.recommended-product__wrapper');
            const content = recommendedProductSection.querySelector('.recommended-product__content');

            console.log('[Recommended Product] Wrapper found:', !!wrapper);
            console.log('[Recommended Product] Content found:', !!content);

            if (wrapper) {
              console.log('[Recommended Product] Wrapper innerHTML length:', wrapper.innerHTML.length);
              if (wrapper.innerHTML.trim().length === 0) {
                console.warn('[Recommended Product] No recommendations available - wrapper is empty');
              }
            }

            if (content) {
              console.log('[Recommended Product] Content innerHTML length:', content.innerHTML.length);
              console.log('[Recommended Product] Content successfully populated');
            } else {
              console.warn('[Recommended Product] Content element not found after replace');
            }

            enrichRenderedDescriptions(recommendedProductSection);
          } else {
            console.warn('[Recommended Product] Block not found in response. Block ID:', blockId);
            console.log('[Recommended Product] Response HTML preview:', text.substring(0, 500));
            // Fallback: try to find by class
            const responseByClass = html.querySelector('.recommended-product');
            if (responseByClass && responseByClass.innerHTML.trim().length) {
              console.log('[Recommended Product] Found by class, using fallback');
              recommendedProductSection.innerHTML = responseByClass.innerHTML;
              enrichRenderedDescriptions(recommendedProductSection);
            } else {
              console.warn('[Recommended Product] No recommendations content found in API response');
            }
          }
        })
        .catch((e) => {
          console.error('[Recommended Product] Error:', e);
        });
    }

    function enrichRenderedDescriptions(container) {
      const cards = container.querySelectorAll('.recommended-product__card[data-product-handle]');
      if (!cards.length) return;

      for (const card of cards) {
        const handle = card.dataset.productHandle;
        if (!handle) continue;

        fetchSupplementalProductData(handle)
          .then((data) => {
            if (!data) return;

            const shortDescription = data.short_description || '';
            if (!shortDescription.trim()) return;

            const truncatedDescription = truncateWords(stripHtml(shortDescription), 15);
            if (!truncatedDescription) return;

            let descriptionElement = card.querySelector('.recommended-product__description');
            if (!descriptionElement) {
              const infoContainer = card.querySelector('.recommended-product__info');
              const priceElement = card.querySelector('.recommended-product__price');
              if (!infoContainer) return;

              descriptionElement = document.createElement('p');
              descriptionElement.className = 'recommended-product__description';
              descriptionElement.setAttribute('data-description-target', '');

              if (priceElement?.parentNode === infoContainer) {
                infoContainer.insertBefore(descriptionElement, priceElement.nextSibling);
              } else {
                infoContainer.appendChild(descriptionElement);
              }
            }

            descriptionElement.textContent = truncatedDescription;
          })
          .catch((error) => {
            if (error?.name === 'AbortError') return;
            console.warn('[Recommended Product] Failed to enrich short description:', error);
          });
      }
    }

    async function fetchSupplementalProductData(handle) {
      const cachedData = productDataCache.get(handle);
      if (cachedData) return cachedData;

      const dataUrl = `/products/${encodeURIComponent(handle)}?view=recommended-data`;
      const response = await fetch(dataUrl, {
        credentials: 'same-origin',
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch product data: ${response.status}`);
      }

      const rawPayload = await response.text();
      let data = null;
      try {
        data = JSON.parse(rawPayload);
      } catch {
        throw new Error('Recommended product data response is not valid JSON');
      }

      const productPayload =
        data?.product && typeof data.product === 'object' ? data.product : null;
      const payloadShortDescription =
        productPayload?.metafields?.custom?.short_description?.value || '';
      const payloadDescription =
        productPayload?.description || productPayload?.body_html || '';
      const normalizedData = {
        short_description: data.short_description || payloadShortDescription,
        description: data.description || payloadDescription,
      };

      productDataCache.set(handle, normalizedData);
      return normalizedData;
    }

    function stripHtml(text) {
      const div = document.createElement('div');
      div.innerHTML = text || '';
      return div.textContent || div.innerText || '';
    }

    function truncateWords(text, maxWords) {
      const words = String(text || '')
        .trim()
        .split(/\s+/)
        .filter(Boolean);
      if (!words.length) return '';
      if (words.length <= maxWords) return words.join(' ');
      return `${words.slice(0, maxWords).join(' ')}...`;
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
